import React from 'react'
import { usePostRequest } from '../hooks/request'
import { ANIMAL_TYPE_LIST } from '../urls'
import { useMessage } from '../hooks/message'
import AnimalTypeForm from './AnimalTypeForm'

export default function AnimalTypeCreate({ onSuccess, onCancel }) {
    const animalTypeCreate = usePostRequest({ url: ANIMAL_TYPE_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await animalTypeCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <AnimalTypeForm loading={animalTypeCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
